export const FETCH_SLIDE_REQUEST = "FETCH_SLIDE_REQUEST";
export const FETCH_SLIDE_SUCCESS = "FETCH_SLIDE_SUCCESS";
export const FETCH_SLIDE_FAILURE = "FETCH_SLIDE_FAILURE";
export const FETCH_SLIDE_INITIAL = "FETCH_SLIDE_INITIAL";
